import moment from 'moment';

export const parseBreakTimes = (breakTimesText) => {
  if (!breakTimesText || !breakTimesText.trim()) return [];

  const ranges = [];
  const lines = breakTimesText.replace(/,/g, '\n').split('\n');

  for (let line of lines) {
    line = line.trim();
    if (line && line.includes('-')) {
      const [start, end] = line.split('-').map(t => t.trim());
      if (start && end) {
        ranges.push({ start, end });
      }
    }
  }

  return ranges;
};

export const createTimeIntervalsWithBreaks = (startTime, endTime, breakRanges = [], intervalHours = 2) => {
  const slots = [];
  let current = moment(startTime, 'h:mm A');
  const end = moment(endTime, 'h:mm A');

  while (current.isBefore(end)) {
    const slotEnd = current.clone().add(intervalHours, 'hours');
    if (slotEnd.isAfter(end)) break;

    const isInBreak = breakRanges.some(breakRange => {
      const breakStart = moment(breakRange.start, 'h:mm A');
      const breakEnd = moment(breakRange.end, 'h:mm A');
      return current.isBefore(breakEnd) && slotEnd.isAfter(breakStart);
    });

    if (!isInBreak) {
      slots.push({
        id: `${current.format('HHmm')}_${slotEnd.format('HHmm')}`,
        start_time: current.format('h:mm A'),
        end_time: slotEnd.format('h:mm A')
      });
    }

    current = slotEnd;
  }

  return slots;
};

export const processTimeSlotsResponse = (apiResponse, intervalHours = 2) => {
  if (!apiResponse?.data?.results || apiResponse.data.results.length === 0) {
    return [];
  }

  
  
  const slots = apiResponse.data.results;

  
  const mappedSlots = slots.map(slot => ({
    id: slot.id,
    start_time: slot.start_time,
    end_time: slot.end_time,
    display_value: slot.display_value || `${slot.start_time} - ${slot.end_time}`,
    active: slot.active !== undefined ? slot.active : true,
  }));

  return mappedSlots;
};

export const getSubmissionValue = (selectedDisplayValue, windowSlots) => {
  if (!selectedDisplayValue || !windowSlots) return selectedDisplayValue;

  console.log('getSubmissionValue - Input:', selectedDisplayValue);
  console.log('getSubmissionValue - Available slots:', windowSlots);

  
  const selectedSlot = windowSlots.find(slot => {
    
    if (slot.display_value && slot.display_value === selectedDisplayValue) {
      return true;
    }

    
    if (slot.start_time && slot.end_time) {
      const slotDisplayValue = `${slot.start_time} - ${slot.end_time}`;
      if (slotDisplayValue === selectedDisplayValue) {
        return true;
      }
    }

    
    if (slot.id === selectedDisplayValue || slot.id === parseInt(selectedDisplayValue)) {
      return true;
    }

    return false;
  });

  console.log('getSubmissionValue - Found slot:', selectedSlot);

  if (selectedSlot) {
    
    const result = selectedSlot.display_value || `${selectedSlot.start_time} - ${selectedSlot.end_time}`;
    console.log('getSubmissionValue - Returning display value:', result);
    return result;
  }

  
  console.log('getSubmissionValue - Returning original value:', selectedDisplayValue);
  return selectedDisplayValue;
};

export const areTimeWindowsDifferent = (window1, window2, windowSlots) => {
  return window1 !== window2;
};